import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedLaundryTransaction, ExtendedLaundryTransactionListResponse, ExtendedLaundryTransactionQueryParams } from '@frontend/transaction/types';

export class TransactionLaundryExtendedClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async fetchExtendedLaundryTransactions(
        queryParams?: ApiQueryParams<ExtendedLaundryTransactionQueryParams>
    ): Promise<ExtendedLaundryTransactionListResponse> {
        return this.apiPaginated<ExtendedLaundryTransactionListResponse, ExtendedLaundryTransactionQueryParams>(
            `${this.endpoint}/laundry-transactions`,
            queryParams
        );
    }

    public static async fetchExtendedLaundryTransaction(accountId: string, transactionId: string): Promise<ExtendedLaundryTransaction> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/laundry-transactions/${transactionId}`);
        return await this.handleResponse<ExtendedLaundryTransaction>(response);
    }
}
